var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-select-button"},[_c('button',{staticClass:"main",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('span',{staticClass:"aisea-text-16-400-dark-gray"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }